<template>
  <PageTemplate>
    <v-breadcrumbs
      :breadcrumbs="breadcrumbs"
    />
    <div class="row">
      <div class="col-md-6">
        <h1>Committee Management</h1>
      </div>
      <div class="col-md-6">
        <v-button-group is-right>
          <v-button @click="showAddModal">
            Add Committee
          </v-button>
        </v-button-group>
      </div>
    </div>

    <v-card title="Committee and Admin List">
      <v-table
        :table="table"
        :is-reduced="true"
        @switchToEdit="EditRow"
      />
    </v-card>
    <!-- ADD/EDIT MODAL   -->
    <v-modal
      v-if="showModal"
      :custom-class="'modal__body committee_modal'"
      @close="closeCommitteeModel"
    >
      <template #header>
        {{ modalName }}
      </template>
      <template v-if="!isConfirmed">
        <v-fieldset
          id="title"
          v-model="newCommittee.committee_name"
          text="Committee Name"
          is-required
          :maxlength="255"
        />
        <!--    Add/Edit members for add action   -->
        <strong>Select members to add to committee</strong>
        <multiselect
          v-model="newCommittee.committee_members"
          tag-placeholder="Add this as new tag"
          placeholder="Select"
          label="label"
          track-by="value"
          :options="users"
          :multiple="true"
          :taggable="true"
        />
        <v-fieldset
          v-if="newCommittee && newCommittee.committee_members && newCommittee.committee_members.length > 0"
          text="Assign Admin"
          :placeholder="'Select'"
          :select-options="newCommittee.committee_members"
          :value="newCommittee.committee_admin_id"
          @input="assignAdmin"
        />
        <!--    Add/Edit members for add action    -->
      </template>
      <template v-else-if="isConfirmed && !isSuccess">
        Are you sure you want to proceed with the following changes:
        <ul>
          <li v-if="originalCommittee.committee_name != newCommittee.committee_name ">
            Changed Committee title from {{ originalCommittee.committee_name }} to {{ newCommittee.committee_name }}.
          </li>
          <li v-if="originalCommittee.committee_admin_id != newCommittee.committee_admin_id">
            Changed admin from {{ originalCommittee.committee_admin }} to {{ newCommittee.committee_admin }}.
          </li>
          <li v-if="addMembers && addMembers.length > 0">
            Add members: {{ addMembers }}
          </li>
          <li v-if="removeMembers && removeMembers.length > 0">
            Remove members: {{ removeMembers }}
          </li>
        </ul>
      </template>
      <template v-else-if="isConfirmed && isSuccess">
        You have successfully made the following changes:
        <ul>
          <li v-if="originalCommittee.committee_name != newCommittee.committee_name ">
            Changed Committee title from {{ originalCommittee.committee_name }} to {{ newCommittee.committee_name }}.
          </li>
          <li v-if="originalCommittee.committee_admin_id != newCommittee.committee_admin_id">
            Changed admin from {{ originalCommittee.committee_admin }} to {{ newCommittee.committee_admin }}.
          </li>
          <li v-if="addMembers && addMembers.length > 0">
            Add members: {{ addMembers }}
          </li>
          <li v-if="removeMembers && removeMembers.length > 0">
            Remove members: {{ removeMembers }}
          </li>
        </ul>
      </template>
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="!isSuccess"
            size="lg"
            :is-disabled="!isChange && editCommittee"
            has-min-width
            @click="submit"
          >
            {{ modalButtonName }}
          </v-button>
          <v-button
            v-else-if="editCommittee && !isConfirmed"
            size="lg"
            has-min-width
            @click="isConfirmed = true"
          >
            {{ modalButtonName }}
          </v-button>
          <v-button
            size="lg"
            color="secondary"
            has-min-width
            @click="closeCommitteeModel"
          >
            {{ isSuccess ? 'Close':'Cancel' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </PageTemplate>
</template>

<script>
  import {mapState} from "vuex";
  import PageTemplate from "../../templates/Page/index.vue";
  import Breadcrumbs from "@/molecules/Breadcrumbs";
  import Card from "@/molecules/Card";
  import Table from "@/molecules/Table";
  import Modal from "@/atoms/Modal";
  import Button from "@/atoms/Button";
  import Fieldset from "@/molecules/Fieldset";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import {columnSort, buildBreadCrumb} from "../../common/tableFunctions";
  import Multiselect from 'vue-multiselect'
  import {
    GET_COMMITTEES,
    GET_MEMBERS,
    GET_ALL_CM,
    ADD_COMMITTEE,
    UPDATE_COMMITTEE_ADMIN
  } from "../../store/actions.type";
  import routes from "@/common/routes";

  export default {
    name: "ManageCommittee",
    components: {
      "v-table": Table,
      "v-breadcrumbs": Breadcrumbs,
      "v-card": Card,
      "v-modal": Modal,
      "v-button": Button,
      "v-fieldset": Fieldset,
      "v-button-group": ButtonGroup,
      Multiselect,
      PageTemplate,
    },
    computed:{
      ...mapState({
        committees: state => state.committees.committees,
        dropdownMembers: state => state.committees.dropdownMembers,
        users: state => state.userRequest.usersListForNewCommittee,
      }),
    },
    data() {
      return {
        table: {
          columns: [
            {
              label: 'Committee ID',
              field: 'committee_id',
              sortFn: columnSort,
              thClass: 'sortable',
              hidden: true,
            },
            {
              label: 'Committee',
              field: 'committee_name',
              sortFn: columnSort,
              thClass: 'sortable',
            },
            {
              label: 'Forum Admin',
              field: 'forum_admin',
              sortFn: columnSort,
              actions: 'dropdown',
              thClass: 'sortable',
            },
            {
              label: 'Action',
              field: 'action',
              sortFn: columnSort,
              actions: 'edit_and_save',
            },
          ],
          rows: [],
          totalRecords: 0,
          initialRowsPerPage: 10
        },
        dropdown:[],
        breadcrumbs: [],
        modalName: null,
        activateModal: false,
        isChange: false,
        isConfirmed: false,
        isSuccess: false,
        newCommittee: {
          committee_name:null,
          committee_admin:null,
          committee_admin_id:null,
          committee_members:[]
        },
        selectedCommitteeId : null,
        originalCommittee: {
          committee_name:null,
          committee_admin:null,
          committee_admin_id:null,
          committee_members:[]
        },
        submitData : null,
        showModal:false,
        addNewCommittee: false,
        editCommittee: false,
        modalButtonName: null,
        addMembers:null,
        removeMembers: null
      };
    },
    watch:{
      addNewCommittee: {
        handler:function(val){
          if(val === true){
            this.modalButtonName = 'Add';
            this.editCommittee = false;
            this.modalName = 'ADD COMMITTEE';
          }
        }
      },
      editCommittee: {
        handler:function(val){
          if(val === true){
            this.addNewCommittee = false;
            this.modalButtonName = 'Edit';
            this.modalName = 'EDIT COMMITTEE';
          }
        }
      },
      newCommittee:{
        deep: true,
        handler: function(val){
          this.isChange = (this.newCommittee.committee_name != this.originalCommittee.committee_name) ||
            (this.newCommittee.committee_admin_id != this.originalCommittee.committee_admin_id) ||
            (this.compareArrObj(this.newCommittee.committee_members, this.originalCommittee.committee_members));
        }
      },
      dropdownMembers:{
        deep:true,
        handler:function(val){
          this.newCommittee.committee_members = JSON.parse(JSON.stringify(this.dropdownMembers));
          this.originalCommittee.committee_members = JSON.parse(JSON.stringify(this.dropdownMembers));
        }
      }
    },
    mounted() {
      this.updateBreadCrumb();
      this.getCommitteeWithAdmin();
      this.getCMUsers();
    },
    methods: {
      compareArrObj:function($arr1,$arr2)
      {
        if($arr1 && $arr2){
          this.removeMembers = $arr2.filter(o => !$arr1.some(v => v.value === o.value)).map(obj => obj.label).join(',');
          this.addMembers = $arr1.filter(o => !$arr2.some(v => v.value === o.value)).map(obj => obj.label).join(',');
          return ($arr2.filter(o => !$arr1.some(v => v.value === o.value)).length > 0 ||
            $arr1.filter(o => !$arr2.some(v => v.value === o.value)).length > 0);
        }
      },
      assignAdmin: function(val){
        this.newCommittee.committee_admin_id = val;
        if(this.editCommittee){
          let selectedUser = this.newCommittee.committee_members.filter(el => el.value == val)[0];
          this.newCommittee.committee_admin = selectedUser.label;
        }
      },
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['All Users'] = routes.ADMIN.USERS;
        breadcrumbs['Manage Committee'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getCMUsers(){
        this.$store.dispatch(GET_ALL_CM);
      },
      getCommitteeWithAdmin: function(){
        this.$store.dispatch(GET_COMMITTEES).then(response => {
          this.table.rows = this.committees;
        })
      },
      getCommitteeMembers:function(id){
        this.$store.dispatch(GET_MEMBERS,id).then(response => {
        })
      },
      EditRow:function(params){
        this.showModal = true;
        this.editCommittee = true;
        this.getCommitteeMembers(params.id)
        this.selectedCommitteeId = params.id;
        this.newCommittee.committee_name = params.name;
        this.newCommittee.committee_admin_id = params.admin_id;
        this.newCommittee.committee_admin = params.admin?params.admin.first_name + ' ' + params.admin.last_name:'';
        this.originalCommittee.committee_name = params.name;
        this.originalCommittee.committee_admin_id = params.admin_id;
        this.originalCommittee.committee_admin = params.admin?params.admin.first_name + ' ' + params.admin.last_name:'';
      },
      submit: function(){
        if(this.addNewCommittee){
          this.add();
        }else if(this.editCommittee && this.isConfirmed){
          this.edit();
        }else{
          this.isConfirmed = true;
        }
      },
      add:function(){
          this.$store.dispatch(ADD_COMMITTEE,this.newCommittee).then(response => {
            if(response.success){
              this.closeCommitteeModel();
              this.getCommitteeWithAdmin();
              this.isConfirmed = false;
              this.$notify({
                title: 'Success',
                text: 'You have successfully added a new committee!',
                type: 'success'
              });
            }else{
              this.$notify({
                title: 'Error',
                text: response.response.data.data,
                type: 'error'
              });
            }
          });
      },
      edit:function(){
        let params = this.newCommittee;   
          
        let adminInMembers = params.committee_members.filter(ele =>params.committee_admin_id == ele.value);
        if(adminInMembers.length === 0) {
          params.committee_admin_id = null;
          params.committee_admin = null;
        }
        this.$store.dispatch(UPDATE_COMMITTEE_ADMIN,[this.selectedCommitteeId,params]).then(response => {
          if(response.success){
            this.isSuccess = true;
          }else{
            this.$notify({
              title: 'Error',
              text: 'The use is not allowed to be a committee\'s admin!',
              type: 'error'
            });
          }
          this.getCommitteeWithAdmin();
        })
          .catch(error => {
            this.$notify({
              title: 'Error',
              text: response.response.data.data,
              type: 'error'
            });
          });
      },
      showAddModal: function(){
        this.showModal = true;
        this.addNewCommittee = true;
      },
      closeCommitteeModel:function(){
        this.showModal = false;
        this.isConfirmed = false;
        this.isSuccess = false;
        this.newCommittee = {
          committee_name:null,
          committee_admin_id:null,
          committee_members: []
        };
      }
    }
  }
</script>
<style lang="scss">
  .committee_modal {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow: unset;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
  </style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>



